





import Vue from 'vue';
import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import {LABEL_ALIGN} from '@/utils/Constants';
import InputMixin from '@/components/input/InputMixin';

@Component({
    components: {}
})
export default class PasswordInput extends Mixins<InputMixin>(InputMixin) {

    public onChangeInput(data: any) {
        this.$emit('input', data);
    }

    public onEnter($event: KeyboardEvent) {
        this.$emit('enter', event);
    }
}
